import { decode } from "he";
import "./css/output.css";
export default function MeasureValue({ label, value, className, ...props }) {
  const computedClassName = ["output", "measure-value", ...className.split(" ")]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      {!!label && (
        <>
          <strong>{label}</strong>&nbsp;
        </>
      )}
      {!value && <span></span>}
      {!!value && (
        <span>
          {value.magnitud}&nbsp;{decode(value.unidad?.html)}
        </span>
      )}
    </div>
  );
}

MeasureValue.defaultProps = {
  className: "",
};
